/**
 * Config-driven SSO tenants. Add a new brand here + assets under /public/assets/{id}.
 * Launch URLs:
 *   ?client_id=luon&redirect_uri=...&state=...
 *   ?client=Mi Tienda  (legacy alias → mi-tienda)
 *   ?client=luon.shop
 */

import manda2Logo from '../images/manda2_logo.jpeg'
import luonLogo from '../images/LUON_Logo_horizontal_tagline.png'
import innovifyLogo from '../images/innovify-brand-board.png'

export const DEFAULT_TENANT_ID = 'manda2'

export const TENANTS = {
  manda2: {
    id: 'manda2',
    displayName: 'MANDA2',
    aliases: ['manda2', 'MANDA2', 'Manda2'],
    logoSrc: manda2Logo,
    favicon: '/favicon.ico',
    themeClass: '',
    logoClass: 'logo-header',
    privacyUrl: 'https://www.manda2.com.mx/aviso-privacidad',
    termsUrl: 'https://www.manda2.com.mx/tyc-promociones',
    promoName: 'MANDA2'
  },
  'mi-tienda': {
    id: 'mi-tienda',
    displayName: 'Mi Tienda',
    aliases: ['mi-tienda', 'Mi Tienda', 'mitienda', 'MiTienda'],
    logoSrc: '/assets/mi-tienda.svg',
    favicon: '/assets/mi-tienda/favicon.ico',
    themeClass: 'mi-tienda',
    logoClass: 'logo-header-mi-tienda',
    privacyUrl: 'https://www.mitienda.mx/aviso-privacidad',
    termsUrl: 'https://www.mitienda.mx/terminos-y-condiciones',
    promoName: 'Mi Tienda'
  },
  luon: {
    id: 'luon',
    displayName: 'Luon',
    aliases: ['luon', 'luon.shop', 'Luon', 'LUON'],
    logoSrc: luonLogo,
    favicon: '/assets/luon/favicon.ico',
    themeClass: 'luon',
    logoClass: 'logo-header-luon',
    privacyUrl: 'https://luon.shop/privacy-policy-cookie-restriction-mode',
    termsUrl: 'https://luon.shop/terms-and-conditions',
    promoName: 'Luon'
  },
  innovafy: {
    id: 'innovafy',
    displayName: 'Innovify',
    aliases: ['innovafy', 'Innovafy', 'innovify', 'Innovify', 'swaggerdoc', 'swaggerdoc-dev'],
    // Supplied Innovify artwork; theme and legal URLs still reuse Luon in DEV.
    logoSrc: innovifyLogo,
    favicon: '/assets/innovify/favicon.png',
    themeClass: 'luon',
    logoClass: 'logo-header-innovafy',
    privacyUrl: 'https://luon.shop/privacy-policy-cookie-restriction-mode',
    termsUrl: 'https://luon.shop/terms-and-conditions',
    promoName: 'Innovify'
  }
}

/** Optional map oauth client_id → tenant id via REACT_APP_CLIENT_TENANT_MAP JSON */
const parseClientTenantMap = () => {
  try {
    const raw = process.env.REACT_APP_CLIENT_TENANT_MAP
    if (!raw) return {}
    return JSON.parse(raw)
  } catch (_) {
    return {}
  }
}

export const CLIENT_ID_TO_TENANT = {
  manda2: 'manda2',
  luon: 'luon',
  'luon.shop': 'luon',
  'mi-tienda': 'mi-tienda',
  'swaggerdoc-dev': 'innovafy',
  swaggerdoc: 'innovafy',
  innovafy: 'innovafy',
  ...parseClientTenantMap()
}

export const getTenantById = (id) => TENANTS[id] || TENANTS[DEFAULT_TENANT_ID]

export const findTenantIdByAlias = (alias) => {
  if (!alias) return null
  const normalized = String(alias).trim()
  const fromClientMap = CLIENT_ID_TO_TENANT[normalized]
  if (fromClientMap && TENANTS[fromClientMap]) return fromClientMap

  const match = Object.values(TENANTS).find((tenant) =>
    tenant.aliases.some((a) => a.toLowerCase() === normalized.toLowerCase())
  )
  return match ? match.id : null
}
